import {Component, NgZone, QueryList, ViewChildren} from '@angular/core';
import {NavController, NavParams, Tab} from 'ionic-angular';
import {DataService} from "../../../providers/data-service";
import {ProfileMenuPage} from "../../sync/profile-menu/profile-menu";
import {ProfilePagePage} from "../../sync/profile-page/profile-page";
import {CheckinMenuPage} from "../../sync/checkin-menu/checkin-menu";
import {RolezinMenuPage} from "../../sync/rolezin-menu/rolezin-menu";
import {WebsiteSpotPage} from "../../sync/website-spot/website-spot";

import {MessageService} from "../../../providers/message-service";
import {CONFIG} from "../../../app/config";
import {Util} from "../../../app/util";

@Component({
    selector: 'page-tabs',
    templateUrl: 'tabs.html'
})
export class TabsPage {

    selectedTabs: number = 0;
    selectedIndex: number = 0;

    entrakiTimeout: Date = null;

    showBottomTabs: boolean = false;

    @ViewChildren(Tab) tab: QueryList<Tab>;

    pagesGroups : any = {

        DEFAULT: [

            //SYNC-APP LOREAN
            {component: ProfilePagePage, title: 'Profile', icon: 'person'},
            {component: CheckinMenuPage, title: 'Checkin', icon: 'list-box'},
            {component: RolezinMenuPage, title: 'Hotfeed', icon: 'flash'},

            //SYNC-APP MYAPP
            {component: ProfileMenuPage, title: 'Profile', icon: 'person'},
            {component: CheckinMenuPage, title: 'Checkin', icon: 'moon'},
            {component: WebsiteSpotPage, title: 'Hotspot', icon: 'quote'},

        ]

    };

    pages: any[] = [];

    constructor(public navCtrl: NavController, public navParams:NavParams, public dataService:DataService,
                public messageService: MessageService, public util: Util, private ngZone: NgZone) {

        let getgroup = this.navParams.get('group');
        this.pages = (getgroup ? this.pagesGroups[getgroup] : this.pages = this.pagesGroups.DEFAULT);

        if (typeof this.navParams.get('index') !== 'undefined') {
            this.selectedIndex = this.util.anyParams(2, this.navParams.get('index'), this.navParams.get('entraki'));
            this.selectedIndex = this.navParams.get('index');
        }

        if (this.pages[0].title == 'Profile' && CONFIG.data.brandap) {
            this.pages[0].title = CONFIG.data.brandap.BrandedNome;
        }

    }

    ionViewDidLoad() {

        // após recarregar a aba, efetuar pushs
        if (this.navParams.get('pushs')) {

            let pushs = this.navParams.get('pushs');
            pushs.forEach((push) => {
                this.tab.toArray().filter(tab => tab.isSelected)[0].push(push.component, push.data, push.options);
            });

        }

    }

    // só é chamado quando acontece change, se já estiver selected não chama aqui
    // unico modo é com click mas não funciona quando usa o .select()
    tabSelected(event) {

        setTimeout(() => {

            let tabsIndex = event.id.split('-')[0].substr(1);
            let tabIndex  = event.id.split('-')[1];

            this.messageService.get('tab.selected').next({
                tabsOld: this.selectedTabs,
                tabsNew: <number>tabsIndex,
                indexOld: this.selectedIndex,
                indexNew: <number>tabIndex
            });


            //Push-Aviso Check-in/out falhar qdo entra no checkin pesquisa!
            let date = new Date();
            let data = new Date();
            date.setSeconds(data.getSeconds() - 30);
            let bool = (!this.entrakiTimeout || date > this.entrakiTimeout);

            if (this.selectedIndex != tabIndex && tabIndex == 1 && bool) {
                //Backup "Entraki-Push"....
                this.entrakiTimeout = new Date();
                (window as any).handappMainInstance.checkinCall(0);
            }


            //Grava Tab Selecionada
            //#AKI-E-LAH# - Troca se chamar manualmente nao cai no tab-menu.ts
            this.dataService.set('tabselected', tabIndex);

            this.selectedIndex = <number>tabIndex;
            this.selectedTabs = <number>tabsIndex;

            this.ngZone.run(() => {});

        }, 150);

    }

}



// WEBPACK FOOTER //
// ./src/pages/both/tabs/tabs.ts